module.exports = __webpack_public_path__ + "static/media/Necchi - Turquoise_Bordeaux.a6627f8c.jpg";